// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// See ADDITIONAL-TERMS.md for the section 7(b) attribution requirement.
//
// Hatch — the palette. Every colour that carries meaning on the play surface lives here so
// contrast.test.ts can pin it to WCAG 1.4.11 (≥3:1 for a non-text graphic; ≥4.5:1 for text)
// against the surface it is actually drawn on. Game state is carried by LIGHTNESS first — a
// FILLED square is bright amber on a dark unknown square, so filled-vs-empty is legible with
// no hue perception at all — and by SHAPE second: a MARK is an ✕ glyph, not merely a colour.

export const PALETTE = {
  stage: '#12151c', // the dark board / page
  stageEdge: '#090b10', // darker vignette / frame a cell can sit against
  panel: '#1b2029', // HUD chips / sheets / tool buttons
  board: '#0e1119', // the grid backing (gaps between cells show as this)
  gridline: '#191f28', // thin separators between cells (decorative structure)

  cellEmpty: '#303845', // an UNKNOWN square — the surface a fill/mark is drawn against
  markGlyph: '#7b8798', // the ✕ stroke on a square marked empty (≥3:1 on cellEmpty)

  fill: '#f2b23a', // a FILLED square (amber). ≥3:1 vs cellEmpty AND vs the stage.
  fillCore: '#ffd98f', // the lit top of a freshly-painted fill (gradient)
  fillEdge: '#c48214', // the shaded bottom of a fill (gradient)

  ink: '#eef2f8', // clue text on the stage / board (≥4.5:1)
  inkDim: '#9aa6b6', // secondary text
  clueDone: '#5fae74', // a clue whose line is fully satisfied (also struck through — shape)

  good: '#39b06e', // solved / correct accent (on stage)
  bad: '#e0503b', // mistake flash (on stage)
  spark: '#f3ad34', // keyboard cursor ring / combo accent (on stage)
} as const;

export type Palette = typeof PALETTE;
